export default __webpack_public_path__ + "static/media/figure_candidat.99729919.png";